var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-image-viewer',_vm._b({on:{"close":function($event){return _vm.$emit('close')}}},'el-image-viewer',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }